import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { FC, memo } from 'react';

import PlanningTemporaryTruckInlineForm from './PlanningTemporaryTruckInlineForm';

type Props = {
  startOn: string;
  endOn: string;
  temporaryTruckDialogOpen: boolean;
  setTemporaryTruckDialogOpen: (val: boolean) => void;
}

const PlanningTemporaryTruckDialog: FC<Props> = memo((
  {
    startOn,
    endOn,
    temporaryTruckDialogOpen,
    setTemporaryTruckDialogOpen,
  }
) => (
  <Dialog open={temporaryTruckDialogOpen} sx={{ m: 0, }} maxWidth="md" fullWidth>
    <DialogTitle sx={{ pt: 2, px: 2, pb: 0, }}>
      仮トラック登録
    </DialogTitle>
    <DialogContent sx={{ p: 2, }}>
      <PlanningTemporaryTruckInlineForm
        startOn={startOn}
        endOn={endOn}
        onSaved={() => setTemporaryTruckDialogOpen(false)}
        onCancel={() => setTemporaryTruckDialogOpen(false)}
      />
    </DialogContent>
  </Dialog>
));

export default PlanningTemporaryTruckDialog;
